module.exports = "/_next/static/images/MapsJettyBackgroundAdangBay-11a375bcdebcb9720dd9e15a6960d1a9.png";